import { useEffect, useState } from 'preact/hooks';
import {
  excludeByCustomerSegments,
  excludeByProductBTGRules,
  type Product
} from '@/domain/Product';
import type { PLPRoute } from '@/domain/Route.ts';
import isPreview from '@/widgets/utils/isPreview.ts';
import { getCustomerProductRules } from '@/widgets/services/ProductService.ts';
import type { CustomerProductRules } from '@/domain/assemblers/ProductAssembler';

/**
 *  This hook's purpose is to display the appropriate products for each phase:
 *
 * - Before hydration + after hydration and NO BTG rules: all products
 * - After hydration and BTG rules: these rules are applied to the products
 */
export default function useProductWithRules(
  products: Product[],
  route: PLPRoute,
  customerProductRules?: CustomerProductRules
) {
  const withCacheBusting = isPreview();
  const [productsWithPreferences, setProductsWithPreferences] =
    useState<Product[]>(products);

  useEffect(() => {
    (async () => {
      try {
        const rules =
          customerProductRules ??
          (await getCustomerProductRules(
            route.market,
            route.channel,
            route.locale,
            withCacheBusting
          ));
        setProductsWithPreferences(
          products.filter(
            (product) =>
              !excludeByProductBTGRules(
                product.productSelections,
                rules.selections
              ) && !excludeByCustomerSegments(product.segments, rules.segments)
          )
        );
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return productsWithPreferences;
}
